/* pv-pin.js — s565 E-2 (rev3: exact pathname match; Codex r1 [B] main-grid scope; li wrapper).
   Move the product card named by ?pv_pin=<handle> to the first slot of the collection grid.
   Contract (E2-LANDING-PIN-SPEC-s565.md §1): existing cards only / handle whitelist / exact handle match /
   no-op if absent or already #1 / run once on first load / silent on error. No URL, cookie or canonical changes. */
(function () {
  try {
    var params = new URLSearchParams(window.location.search);
    var handle = params.get('pv_pin');
    if (!handle || !/^[a-z0-9]+(?:-[a-z0-9]+)*$/.test(handle) || handle.length > 120) return;
    var run = function () {
      try {
        // Codex r1 [B]: scope to the MAIN collection grid only (theme id on the <ul> when non-empty; empty-collection
        // rescue / recommendation lists never carry this id) — anything else = no-op per contract §1.3
        var list = document.getElementById('main-collection-product-grid');
        if (!list || !list.classList.contains('productListing')) return;
        var links = list.querySelectorAll('.product-item a[href*="/products/"]');
        var card = null;
        for (var i = 0; i < links.length; i++) {
          var href = links[i].getAttribute('href') || '';
          var path = href.split('#')[0].split('?')[0];          // drop query/hash; works for relative + absolute
          var m = /\/products\/([^\/]+)\/?$/.exec(path);
          if (m && m[1] === handle) { card = links[i].closest('.product-item'); if (card) break; }
        }
        if (!card) return;                                   // not in this collection / not on page 1 → nothing
        var host = card.parentElement;
        var item = (host && host.parentElement === list) ? host : card;   // <li> wrapper if present
        if (item.parentElement !== list) return;
        if (list.firstElementChild === item) return;         // already #1 → idempotent
        list.insertBefore(item, list.firstElementChild);
        item.setAttribute('data-pv-pinned', '1');
      } catch (e) { /* silent */ }
    };
    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', run, { once: true });
    else run();
    // no MutationObserver on purpose: user filter/sort or AJAX re-render must NOT be overridden (contract §1.4)
  } catch (e) { /* silent */ }
})();
